import { ShareAltOutlined } from '@ant-design/icons';
import { Category, Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { MenuItemType } from 'antd/es/menu/interface';

export const Sharing = (
    row: Category | Document,
    fetchData: () => void,
): MenuItemType => {
    const { openModal } = useModal();

    return {
        key: 'Sharing',
        label: 'Access/Sharing',
        onClick: () => {
            openModal('guestTeamModal', {
                entity: row,
            }, {
                onSubmit: () => {
                    fetchData();
                },
                onClose: () => {
                    fetchData();
                },
            });
        },
        icon: <ShareAltOutlined />,
    };
}